import { warn } from '../../logger';
import { InternalElementFactoryOptions, SdkElementFactoryOptions } from '../../model';
import { recordEvent } from '../../telemetry';
import { parseSDKOptions } from './contracts/appearance';

export const validateElementOptions = async (options?: SdkElementFactoryOptions) => {
  await recordEvent('sdk_elements_init_options', options);

  const { success, data, error } = parseSDKOptions(options);

  if (!success) {
    warn('invalidSDKOptions', error.flatten().fieldErrors);
    await recordEvent('sdk_elements_options_validated', {
      warnings: error.flatten().fieldErrors,
      ...options
    });

    return {
      appearance: { fonts: [], variables: {} },
      locale: 'en'
    } as InternalElementFactoryOptions;
  }

  return data as InternalElementFactoryOptions;
};
